import React, { Component } from "react";
import * as d3 from "d3";
import { Force } from "d3";
const gaussian = require("gaussian");

import styles from "./PowderPile.module.scss";
import { tickStep, SimulationNodeDatum } from "d3";
import { pileProps } from "../../../interfaces/interfaces";

class PowderPile extends Component<pileProps> {
  state: {
    powderSize: number;
    spacing: number;
    numGranules: number;
    height: number;
    width: number;
    yForce: number;
    simulation: d3.Simulation<{}, undefined>;
    granules: {}[];
  };

  constructor(props: pileProps) {
    super(props);
    this.state = {
      ...props,
      powderSize: 2,
      spacing: 1,
      numGranules: Math.min(1000, window.innerWidth),
      yForce: 0.1,
      simulation: d3.forceSimulation(),
      granules: []
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.initializePositions();
  }

  getDistribution() {
    const distribution = [];
    const model = gaussian(
      this.state.width / 2,
      Math.pow(this.state.width / 6, 2)
    );
    for (let i = 0; i < this.state.width; i++) {
      const density = model.pdf(i);
      let copies = Math.round(density * this.state.numGranules);
      while (copies > 0) {
        distribution.push(i);
        copies--;
      }
    }

    return distribution;
  }

  initializePositions() {
    const distribution = this.getDistribution();
    this.state.granules = d3.range(this.state.numGranules).map((d: any) => {
      return { radius: this.state.powderSize };
    });
    let positionedGranules = this.state.granules;

    positionedGranules.forEach((d: any, i: number) => {
      d.x = distribution[i] ? distribution[i] : this.state.width / 2;
      d.y = Math.random() * -1000;
    });

    this.setState({ granules: positionedGranules }, () => this.simulatePile());
  }

  simulatePile() {
    this.state.simulation
      .nodes(this.state.granules)
      .force(
        "gravity",
        d3.forceY(this.state.height).strength(this.state.yForce)
      )
      .force(
        "collision",
        d3
          .forceCollide()
          .radius((d: any) => d.radius + this.state.spacing)
          .strength(1)
      )
      .on("tick", this.ticked.bind(this));
  }

  ticked() {
    let nodes = d3
      .select("#footerAnimation")
      .selectAll("circle")
      .data(this.state.granules);

    nodes
      .enter()
      .append("circle")
      .attr("r", (d: any) => d.radius)
      .merge((nodes as unknown) as d3.Selection<
        SVGCircleElement,
        {},
        d3.BaseType,
        {}
      >)
      .attr("cx", (d: any) => d.x)
      .attr("fill", "white")
      .attr("cy", (d: any) => {
        d.y = Math.min(this.state.height - this.state.powderSize, d.y);
        return d.y;
      });

    nodes.exit().remove();
  }

  resize() {
    this.state.simulation.stop();
  }

  render() {
    return <svg className={styles.powder} id="footerAnimation" />;
  }
}

export default PowderPile;
